export default __webpack_public_path__ + "static/media/logout1.a6fdf892.svg";